export default __webpack_public_path__ + "static/Sunday-c3175290fe91487f8e2e706f57d2e114.png";